import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'countToText',
})
export class CountToTextPipe implements PipeTransform {
	transform(count: number | string): string {
		switch (count) {
			case 1:
				return 'כניסה';
			case -1:
				return 'יציאה';
			default:
				return String(count);
		}
	}
}
